import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import { icon } from './ui';
import { portalEvent, portalHome } from './portalApi';
class PortalDataComponent extends Component {
  data = {
    socials: [],
    partners: [],
    team: [],
    roles: []
  };
  oninit(v) {
    super.oninit(v);
    portalHome().then(data => {
      this.data = data;
      m.redraw();
    });
  }
  exit(type, url) {
    portalEvent({
      action: 'analytics',
      consent: localStorage.getItem('nt-analytics-consent') === 'yes',
      visitor_id: localStorage.getItem('nt-visitor-id') || 'anonymous',
      event_type: type,
      path: location.pathname,
      target_url: url,
      browser: navigator.userAgent.slice(0, 80),
      device: matchMedia('(max-width:767px)').matches ? 'mobile' : 'desktop'
    }).catch(() => null);
  }
}
export class TeamOnlineWidget extends PortalDataComponent {
  view() {
    const team = (this.data.team || []).filter(user => user.online);
    return m("section", {
      className: "NtCard NtTeamOnline"
    }, m("div", {
      className: "NtCard-title"
    }, "Ekipa online"), team.length ? m("div", null, team.map(user => m(Link, {
      href: `/u/${encodeURIComponent(user.username)}`
    }, m("span", {
      className: "NtTeamOnline-avatar"
    }, user.avatar_url ? m("img", {
      src: user.avatar_url,
      alt: ""
    }) : m("b", null, String(user.username).charAt(0).toUpperCase())), m("span", null, m("strong", {
      style: {
        color: user.color || '#e8eaec',
        '--role-color': user.color || '#e8eaec',
        '--role-background': user.background || 'transparent'
      },
      className: `NtNickEffect is-${user.effect || 'none'}`
    }, user.username), m("small", null, user.display_title || user.custom_title || user.role_name || user.team_name)), m("i", null)))) : m("p", null, "Obecnie nikt z ekipy nie jest online."));
  }
}
export default class PortalWidgets extends PortalDataComponent {
  view() {
    const partners = this.data.partners || [];
    const socials = this.data.socials || [];
    return m('[', null, partners.length ? m("section", {
      className: "NtCard NtPartners"
    }, m("div", {
      className: "NtCard-title"
    }, "Partnerzy"), m("div", {
      className: "NtPartners-grid"
    }, partners.map(item => m("a", {
      className: "NtPartnerCard",
      href: item.url,
      target: "_blank",
      rel: "noopener noreferrer",
      style: {
        '--partner-accent': item.accent_color || '#d7a83b'
      },
      onclick: () => this.exit('partner_exit', item.url)
    }, item.image_url ? m("img", {
      className: "NtPartnerCard-bg",
      src: item.image_url,
      alt: ""
    }) : m("span", {
      className: "NtPartnerCard-fallback"
    }, icon('fas fa-handshake')), m("span", {
      className: "NtPartnerCard-shade"
    }), m("span", {
      className: "NtPartnerCard-content"
    }, m("small", null, "PARTNER NOVATRUCK & RP"), m("strong", null, item.name), m("em", null, item.description || 'Oficjalny partner społeczności NovaTruck & RP')), m("span", {
      className: "NtPartnerCard-action"
    }, icon('fas fa-external-link-alt')))))) : m("section", {
      className: "NtCard NtPartners NtPartners--empty"
    }, m("div", {
      className: "NtCard-title"
    }, "Partnerzy"), m("p", null, "Partnerstwa dodane i aktywowane w Nova Control Center pojawi\u0105 si\u0119 tutaj.")), socials.length ? m("section", {
      className: "NtCard NtSocials"
    }, m("div", {
      className: "NtCard-title"
    }, "Znajd\u017A nas"), m("div", null, socials.map(item => m("a", {
      href: item.url,
      target: "_blank",
      rel: "noopener noreferrer",
      style: {
        '--social': item.color
      },
      onclick: () => this.exit('social_exit', item.url)
    }, icon(item.icon || 'fas fa-share-alt'), m("span", null, item.label))))) : null);
  }
}
export class RoleLegend extends PortalDataComponent {
  view() {
    const roles = this.data.roles || [];
    if (!roles.length) return null;
    return m("section", {
      className: "container NtRoleLegend"
    }, m("header", null, m("small", null, "NOVA COMMUNITY"), m("h3", null, "Legenda rang"), m("p", null, "Kolory, ikony i efekty pomagaj\u0105 szybko rozpozna\u0107 funkcj\u0119 u\u017Cytkownika na forum.")), m("div", {
      className: "NtRoleLegend-grid"
    }, roles.map(role => m("article", {
      style: {
        '--role-color': role.color || '#d7a83b',
        '--role-background': role.background || 'transparent'
      }
    }, m("span", {
      className: `NtRoleLegend-icon NtNickEffect is-${role.effect || 'none'}`
    }, icon(role.icon || 'fas fa-circle')), m("div", null, m("strong", {
      className: `NtNickEffect is-${role.effect || 'none'}`
    }, role.short_name || role.name), m("small", null, role.category || 'Społeczność'), m("p", null, role.description || role.name))))));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/PortalWidgets', PortalWidgets);